import type { AppModule } from '@/types'
import * as CookieConsent from 'vanilla-cookieconsent'

import 'vanilla-cookieconsent/dist/cookieconsent.css'

const defaultCookieConsentConfig: CookieConsent.CookieConsentConfig = {
  categories: {
    necessary: {
      enabled: true, // this category is enabled by default
      readOnly: true, // this category cannot be disabled
    },
    analytics: {},
  },
  autoClearCookies: true, // default: false
  manageScriptTags: true, // default: false
  onConsent() {},
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: '🍪 We use cookies!',
          description:
                  'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage Individual preferences',
        },
        preferencesModal: {
          title: 'Manage cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Accept current selection',
          closeIconLabel: 'Close modal',
          sections: [
            {
              title: 'Cookie usage 📢',
              description:
                            'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.',
            },
            {
              title: 'Strictly necessary cookies',
              description:
                            'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
              linkedCategory: 'necessary',
            },
            {
              title: 'Performance and Analytics cookies',
              description:
                            'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
              linkedCategory: 'analytics',
            },
            {
              title: 'More information',
              description:
                            'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="https://fluctuo.com/">contact us</a>.',
            },
          ],
        },
      },
    },
  },
}

export default {
  install: (app) => {
    if (!document.getElementById('cc--main')) {
      const cc = CookieConsent
      const cookieConsent = {
        ...cc,
        setup(config: CookieConsent.CookieConsentConfig) {
          cookieConsent.run({
            ...defaultCookieConsentConfig,
            ...config,
          })
        },
      }

      app.config.globalProperties.cookieConsent = cookieConsent
      app.provide('cookieConsent', cookieConsent)
    }
  },
} as AppModule
